import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';
import { Link } from 'react-router-dom';
import './main.css';
import t from '../../../i8n';

export default
class NotFoundScreen extends React.Component {
	render(){
		return (
			<div className="not-found-screen">
				<span className="not-found-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></span>
				<h3>{t({
					pl: 'Podstrona której szukasz nie istnieje.',
					en: 'The site you\'re looking for does not exist.'
				})}</h3>
				<p>{t({
					pl: 'Być może spowodowane jest to aktualizacją strony, lub nieprawidłowym linkiem w który wszedłeś.',
					en: 'This might be caused by a website update, or an invalid link that brought you here.'
				})}</p>
				<p>{t({
					pl: 'Zacznij od nowa, najlepiej od',
					en: 'Try starting again from the'
				})} <Link to="/">{t({pl: 'strony głównej', en: 'main page'})}</Link>.</p>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/Screens/404/index.js